module.exports = __webpack_public_path__ + "static/media/girl.971b5901.svg";